import {refreshFuneralPolicy,funeralAllowed} from './welch-funeral-notice.js';
import './welch-date-picker.js';
import {CartLinesUpdateEvent} from '@shopify/events';
import {editCartItem, messageProperties, funeralProperties} from './welch-cart-edit-core.js';
const root = () => window.Shopify?.routes?.root || '/';
async function request(path, body) {
  const response = await fetch(root() + path, {method: body ? 'POST' : 'GET', cache: 'no-store', signal: AbortSignal.timeout(20000),
    headers: body ? {'Content-Type':'application/json'} : {}, body: body ? JSON.stringify(body) : undefined});
  const data = await response.json();
  if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Unable to update your basket. Please try again.');
  return data;
}
let active = false;
document.addEventListener('click', async event => {
  const trigger = event.target.closest('[data-welch-edit], [data-welch-replace]');
  if (!trigger || active) return;
  event.preventDefault(); active = true;
  const replace = trigger.hasAttribute('data-welch-replace');
  const key = trigger.dataset.welchEdit || trigger.dataset.welchReplace;
  const dialog = document.createElement('dialog');dialog.className = 'welch-cart-editor';
  dialog.innerHTML = `<form><h2 tabindex="-1"></h2><p data-intro></p>
    <div data-search-panel><label>Find a replacement product<input type="search" data-search autocomplete="off"></label><button type="button" data-find>Search products</button><ul data-results></ul></div>
    <p data-product></p><label>Size / option<select data-variant required></select></label>
<fieldset data-funeral-details hidden><legend>Funeral details</legend>
<label>Deceased’s name<input data-deceased maxlength="200" disabled></label>
<label for="welch-cart-funeral-funeral-date">Funeral date</label>
    <welch-date-picker data-funeral-notice>
      <input id="welch-cart-funeral-funeral-date" type="text" name="properties[Funeral date]" placeholder="dd/mm/yyyy" inputmode="numeric" autocomplete="off" maxlength="10"  aria-expanded="false" aria-controls="welch-cart-funeral-calendar">
      <div id="welch-cart-funeral-calendar" class="welch-calendar" data-calendar hidden role="group" aria-label="Choose funeral date">
        <div class="welch-calendar__header">
          <button type="button" data-prev aria-label="Previous month">‹</button>
          <span data-month aria-live="polite"></span>
          <button type="button" data-next aria-label="Next month">›</button>
        </div>
        <div class="welch-calendar__week" aria-hidden="true"><span>M</span><span>T</span><span>W</span><span>T</span><span>F</span><span>S</span><span>S</span></div>
        <div class="welch-calendar__days" data-days></div>
        <button type="button" class="welch-calendar__close" data-close>Close calendar</button>
      </div>
    </welch-date-picker>
<label>Funeral time<select name="properties[Funeral time]" data-funeral-time disabled><option value="">Select funeral time</option></select></label>
<p>Please choose an available funeral date and time. For urgent requests, call <a href="tel:01159737888">0115 973 7888</a>.</p></fieldset>
    <div data-message-panel><label>Card message<textarea data-card rows="4"></textarea></label><label class="welch-cart-editor__check"><input type="checkbox" data-no-card> I don’t want to include a card message</label></div>
    <p data-status role="status" aria-live="polite"></p><div class="welch-cart-edit-actions"><button type="submit" data-save disabled>Save changes</button><button type="button" data-cancel>Cancel</button></div></form>`;
  document.body.append(dialog);
  const q = selector => dialog.querySelector(selector);
  q('h2').textContent = replace ? 'Replace product' : 'Edit item';
  q('[data-intro]').textContent = 'Your delivery address stays in the basket. Existing gift details and extras are kept.';
  q('[data-search-panel]').hidden = !replace;
  let saving = false, product, old, hasMessage, isFuneral, generation = 0;
  const close = () => { if (saving) return; dialog.close();dialog.remove();active = false;trigger.focus(); };
  q('[data-cancel]').onclick = close;
  dialog.addEventListener('cancel', event => {event.preventDefault();close();});
  dialog.showModal();q('h2').focus();
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:window.Shopify?.currency?.active || 'GBP'}).format(value/100);
  async function choose(handle, selected) {
    const current = ++generation;q('[data-save]').disabled = true;
    const result = await request('products/' + encodeURIComponent(handle) + '.js');
    if (current !== generation || !dialog.isConnected) return;
    if (result.requires_selling_plan) throw new Error('Please choose a product available as a one-off purchase.');
    product = result;q('[data-product]').textContent = result.title;
    const select = q('[data-variant]');select.replaceChildren();
    for (const variant of result.variants) {
      const option = document.createElement('option');option.value = variant.id;
      option.textContent = `${variant.title} — ${money(variant.price)}${variant.available ? '' : ' — Sold out'}`;
      option.disabled = !variant.available && String(variant.id) !== String(selected);select.append(option);
    }
    const available = result.variants.find(v => String(v.id) === String(selected)) || result.variants.find(v => v.available);
    select.value = available ? available.id : '';
    q('[data-save]').disabled = !available;
    q('[data-status]').textContent = available ? '' : 'This product is currently unavailable.';
  }
  try {
    const cart = await request('cart.js');if (!dialog.isConnected) return;
    old = cart.items.find(item => item.key === key);if (!old) throw new Error('This item has changed. Close this window and try again.');
    hasMessage = !old.properties?.['For bouquet'] && (!!old.properties?._welch_gift_group || 'Card message' in (old.properties || {}) || 'Card message preference' in (old.properties || {}));
    q('[data-message-panel]').hidden = !hasMessage;
    q('[data-card]').value = old.properties?.['Card message'] || '';
    q('[data-card]').maxLength = Number(document.documentElement.dataset.welchMessageLimit) || 1000;
    q('[data-no-card]').checked = !q('[data-card]').value;
    q('[data-card]').disabled = q('[data-no-card]').checked;
    q('[data-no-card]').onchange = () => {q('[data-card]').disabled = q('[data-no-card]').checked;};
    isFuneral = !old.properties?.['For bouquet'] && String(old.properties?.Occasion||'').trim().toLowerCase()==='funeral';
    const funeralPanel=q('[data-funeral-details]');funeralPanel.hidden=!isFuneral;
    funeralPanel.querySelectorAll('input,select').forEach(field=>{field.disabled=!isFuneral;field.required=isFuneral;});
    if(isFuneral){
      q('[data-deceased]').value=old.properties?.['Deceased’s name']||'';
      const date=funeralPanel.querySelector('input[name="properties[Funeral date]"]'),time=q('[data-funeral-time]');
      date.value=old.properties?.['Funeral date']||'';
      for(let minutes=540;minutes<=1080;minutes+=15){const value=String(Math.floor(minutes/60)).padStart(2,'0')+':'+String(minutes%60).padStart(2,'0');time.add(new Option(value,value));}
      time.value=old.properties?.['Funeral time']||'';
      const updateTimes=()=>{for(const option of time.options)if(option.value)option.disabled=!funeralAllowed(date.value,option.value);};
      date.addEventListener('change',updateTimes);
      time.addEventListener('change',()=>funeralPanel.querySelector('welch-date-picker').validate());
      await refreshFuneralPolicy();if(!dialog.isConnected)return;updateTimes();
    }
    await choose(trigger.dataset.productHandle, old.variant_id);
  } catch (error) {q('[data-status]').textContent = error.message;}
  let searchGeneration = 0;
  q('[data-find]').onclick = async () => {
    const query = q('[data-search]').value.trim();if (!query) return;
    const current = ++searchGeneration;q('[data-status]').textContent = 'Finding products…';
    try {
      const data = await request('search/suggest.json?' + new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'10','resources[options][unavailable_products]':'hide'}));
      if (current !== searchGeneration || !dialog.isConnected) return;
      const list = q('[data-results]');list.replaceChildren();
      for (const match of data.resources?.results?.products || []) {
        const li = document.createElement('li'), button = document.createElement('button');button.type = 'button';button.textContent = match.title;
        button.onclick = () => choose(match.handle).catch(error => {q('[data-status]').textContent = error.message;});li.append(button);list.append(li);
      }
      q('[data-status]').textContent = list.children.length ? 'Choose a product, then select its size below.' : 'No products found. Try another name.';
    } catch (error) {q('[data-status]').textContent = error.message;}
  };
  q('[data-search]').addEventListener('keydown', event => {if(event.key === 'Enter'){event.preventDefault();q('[data-find]').click();}});
  q('form').onsubmit = async event => {
    event.preventDefault();if (saving || !old || !product) return;
    let properties;
    try {properties = hasMessage ? messageProperties(old.properties, q('[data-card]').value, q('[data-no-card]').checked) : {...old.properties};}
    catch(error) {q('[data-status]').textContent = error.message;return;}
    const variant = q('[data-variant]').value;if (!variant) return;
    saving = true;
    try {if(isFuneral){await refreshFuneralPolicy();properties=funeralProperties(properties,q('[data-deceased]').value,q('[name="properties[Funeral date]"]').value,q('[data-funeral-time]').value);}}
    catch(error){saving=false;q('[data-status]').textContent=error.message;return;}
    const controls = [...dialog.querySelectorAll('input,select,textarea,button')];const states = controls.map(c=>c.disabled);controls.forEach(c=>c.disabled=true);
    const lock = event => {if(!dialog.contains(event.target)){event.preventDefault();event.stopImmediatePropagation();}};
    document.addEventListener('click',lock,true);document.addEventListener('submit',lock,true);
    document.querySelectorAll('welch-cart-delivery').forEach(form => form.dispatchEvent(new Event('welch-delivery-departing')));
    q('[data-status]').textContent = 'Updating your basket…';
    let error;
    try {
      await editCartItem(request,key,variant,properties,product.title,crypto.randomUUID());
    }
    catch(e) {error=e;}
    try {
      const cart = await request('cart.js');
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(e=>e.dataset.sectionId))].slice(0,5);
      const sections = sectionIds.length ? await request('cart?sections='+encodeURIComponent(sectionIds.join(','))) : {};
      document.dispatchEvent(new CartLinesUpdateEvent({action:'update',context:'cart',lines:[],promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{sections,items:cart.items,itemCount:cart.item_count,source:'welch-cart-editor',didError:false}})}));
    } catch(e) {error ||= new Error('Your basket may have updated, but could not be displayed. Please refresh before making another change.');}
    finally {document.removeEventListener('click',lock,true);document.removeEventListener('submit',lock,true);saving=false;}
    if (error) {
      q('[data-status]').textContent=error.message;
      // Never repeat an uncertain replacement from the old item snapshot.
      q('[data-cancel]').disabled=false;q('[data-cancel]').textContent='Close and review basket';
    } else close();
  };
});
